import addLangAndTzInHeaders from './addLangAndTzInHeaders'

// ! Pass interceptor to use in this list
const requestInterceptorList = [addLangAndTzInHeaders]

export default requestInterceptorList
